import { MDXComponents } from 'mdx/types'
import React from 'react'

const H_FONT_STYLE = 'tracking-tight text-white'
const h1 = 'mb-2 mt-2 text-3xl lg:text-4xl ' + H_FONT_STYLE
const h2 = 'mb-4 mt-2 text-2xl lg:text-3xl ' + H_FONT_STYLE
const h3 = 'mb-4 mt-2 text-xl lg:text-2xl ' + H_FONT_STYLE
const h4 = 'mb-4 mt-2 text-lg lg:text-xl ' + H_FONT_STYLE

export function useMDXComponents(components: MDXComponents): MDXComponents {
  return {
    p: (props: React.ComponentPropsWithoutRef<'p'>) => <p {...props} className='pt-3 pb-3 text-gray-300' />,
    a: (props: React.ComponentPropsWithoutRef<'a'>) => (
      <a {...props} className='no-underline hover:underline text-blue-400' />
    ),
    ol: (props: React.ComponentPropsWithoutRef<'ol'>) => <ol {...props} className='list-decimal' />,
    ul: (props: React.ComponentPropsWithoutRef<'ul'>) => <ul {...props} className='list-disc' />,
    li: (props: React.ComponentPropsWithoutRef<'li'>) => <li {...props} className='p-1 ml-10' />,
    h1: (props: React.ComponentPropsWithoutRef<'h1'>) => <h1 {...props} className={h1} />,
    h2: (props: React.ComponentPropsWithoutRef<'h2'>) => <h2 {...props} className={h2} />,
    h3: (props: React.ComponentPropsWithoutRef<'h3'>) => <h3 {...props} className={h3} />,
    h4: (props: React.ComponentPropsWithoutRef<'h4'>) => <h4 {...props} className={h4} />,
    hr: (props: React.ComponentPropsWithoutRef<'hr'>) => <hr {...props} className='my-8 border-gray-700' />,
    pre: (props: React.ComponentPropsWithoutRef<'pre'>) => <pre {...props} className='text-sm' />,
    ...components
  }
}
